import { useMemo } from "react";
import { Avatar, Em, Flex, Text } from "@radix-ui/themes";
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from "@/components/ui/hover-card";
import { Team } from "../Explore.model";

export function TeamFormatter({ value }: { value?: Team[] }) {
  const teams = useMemo(() => {
    if (value == null) return [];

    const newValue = Array.isArray(value) ? value : [value];

    let unknownAgentIndex = 1;

    return newValue
      .map((team) => {
        const name =
          team.name != null && team.name !== ""
            ? team.name
            : `Unknown Team ${unknownAgentIndex++}`;

        return {
          ...team,
          name,
        };
      })
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [value]);

  if (value == null || teams.length === 0) {
    return (
      <Text color={"gray"} size={"1"}>
        <Em>No team</Em>
      </Text>
    );
  }

  return (
    <Flex gap={"1"} align={"center"}>
      <Text size={"1"} weight={"medium"}>
        {teams[0].name}
      </Text>

      {teams.length > 1 && (
        <HoverCard>
          <HoverCardTrigger>
            <Avatar
              size={"1"}
              fallback={`+${teams.length - 1}`}
              color={"gray"}
              radius={"full"}
            />
          </HoverCardTrigger>

          <HoverCardContent side="bottom" sideOffset={8} align="start">
            <Flex direction={"column"} gap={"1"}>
              {teams.slice(1).map((team) => {
                return (
                  <Text key={team.externalId} size={"2"} weight={"medium"}>
                    - {team.name}
                  </Text>
                );
              })}
            </Flex>
          </HoverCardContent>
        </HoverCard>
      )}
    </Flex>
  );
}
